const Routes = {
	APP_ENTRY: () => "/app-entry",
	APP_REVIEW: () => "/app-review",
	APP_ENTRY_APPLICATION: (id) => `/app-entry/application/${id}`,
	DEAL_MAKER:() => "deal-maker",
	DOCUMENT_DATA_REVIEW: () => "/document-data-review",
	DOCUMENT_SENT: () => "/document-sent",
	DOCUMENT_REVIEW: () => "/document-review",
	VERBAL_DNA: () => "/verbal-dna",
	PRE_CREDIT_REVIEW: () => "/precredit-review",
	CREDIT_REVIEW: () => "/credit-review",
	CREDIT_ADJUDICATION: () => "/credit-adjudication",
	FUNDING_REVIEW: () => "/funding-review",
	FUNDED_CONFIRMATION: () => "/funded-confirmation",
};

export default Routes;
